import type { Level } from '../../types';
import { colors, css } from './utils';

export function Console(): ClassDecorator {
    return function (target) {
        for (const method of Object.keys(colors) as Level[]) {
            const decorate = function (...args: unknown[]) {
                const params = [...args];

                if (typeof params[0] !== 'string') params.unshift('%o');

                if (process.env.NODE_ENV === 'development') {
                    console[method](
                        `%capp%c ${params[0]}`,
                        css(colors[method]).join(';'),
                        'color: inherit',
                        ...params.slice(1)
                    );
                } else {
                    console[method](...args);
                }
            };

            Object.defineProperty(target.prototype, method, {
                configurable: true,
                writable: true,
                value: decorate,
            });
        }
    };
}
